import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
import { Card, Flex, Heading, Button } from "@radix-ui/themes";
import { getPaymentReferenceReport, getPaymentReferenceReportAdvanced } from "../../../services/finance/reports";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { PAGE_NUMBER, PAGE_SIZE } from "../../../utils/constants";
import DateFieldComponent from "../../../components/inputs/Datefield/DatefieldComponent";
import { useGetPaymentTypesQuery } from "../../../hooks/useGetPaymentTypesQuery";

const periodOptions = [
    { value: "daily", label: "Diário" },
    { value: "monthly", label: "Mensal" },
    { value: "annual", label: "Anual" },
];

const columnNamesMap = {
    codigo: "Código",
    nome: "Nome do Estudante",
    entidade: "Entidade Bancária",
    referencia: "Referência",
    valorPago: "Valor Pago",
    tipoPagamento: "Tipo de pagamento",
    dataPagamento: "Data de Pagamento",
    mes: "Mês",
};

export const GetPaymentReferenceReportAdvanced = () => {
    const [currentPage, setCurrentPage] = useState(PAGE_NUMBER);
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const { control, handleSubmit, watch, setValue, formState: { errors } } = useForm({
        defaultValues: {
            PeriodType: 'daily',
            ReferenceDate: new Date().toISOString().split('T')[0],
            StartDate: "",
            EndDate: "",
            StudentName: "",
            Entity: "",
            Reference: "",
            IdPaymentType: "",
        },
    });
    const { data: paymentTypesData, status: paymentTypesStatus, isError: isErrorPaymentTypes, isLoading: isLoadingPaymentTypes } = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 400 });

    const filters = watch();

    const memoizedFilters = useMemo(() => filters, [filters]);

    const { data, status, refetch } = useQuery(
        ["getPaymentReferenceReportAdvanced", memoizedFilters],
        async () => await getPaymentReferenceReportAdvanced(memoizedFilters),
        {
            //  keepPreviousData: true, 
        refetchOnWindowFocus: false
        }
    );

    const onSubmit = handleSubmit(() => {
        refetch();
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        // setValue("PageNumber", page);
    };

    const handlePageSizeChange = (size: number) => {
        setPageSize(size);
        setCurrentPage(PAGE_NUMBER);
        // setValue("PageSize", size);
    };

    return (
        <>
            <Card>
                <Flex direction="column" gap="4">
                    <Heading> Relatório de Pagamentos</Heading>
                    <form onSubmit={onSubmit}>
                        <Flex gap="3" direction={'row'}>
                            <SelectComponent
                                name="PeriodType"
                                label="Tipo de Período"
                                control={control}
                                options={periodOptions}
                                errors={errors}
                                style={{width:'100%'}}
                            />
                            <SelectComponent
                                name="IdPaymentType"
                                label="Tipo de pagamento"
                                control={control}
                                errors={errors}
                                options={paymentTypesData?.items.map((p) => ({
                                    value: p.id ?? "",
                                    label: p.description ?? "",
                                }))}
                                style={{ width: '100%' }}
                                itemsLoading={isLoadingPaymentTypes}
                            />
                            <DateFieldComponent
                                name="ReferenceDate"
                                label="Dia"
                                control={control}
                                errors={errors}
                                style={{width:'100%'}}

                            />
                            <DateFieldComponent
                                name="StartDate"
                                label="Data Início"
                                control={control}
                                errors={errors}
                                style={{width:'100%'}}

                                 />
                            <DateFieldComponent
                                name="EndDate"
                                label="Data Fim"
                                control={control}
                                errors={errors}
                                style={{width:'100%'}}

                            />
                        </Flex>

                        <Flex gap="3"mt="2">
                            <TextFieldComponent
                                name="StudentName"
                                label="Nome do Estudante"
                                control={control}
                                errors={errors}
                                style={{width:'100%'}}

                            />
                            <TextFieldComponent
                                name="Entity"
                                label="Entidade Bancária"
                                control={control}
                                errors={errors}
                                style={{width:'100%'}}

                            />
                            <TextFieldComponent
                                name="Reference"
                                label="Referência"
                                control={control}
                                errors={errors}
                                style={{width:'100%'}}

                            />
                        </Flex>

                        {/* <Flex justify="end" mt="3">
                            <Button type="submit" variant="solid">
                                Aplicar Filtros
                            </Button>
                        </Flex> */}
                    </form>
                </Flex>
            </Card>

            <Lists
                status={status}
                TableComponent={() => (
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.pagamentos.map((item: any) => ({
                            ...item,
                            dataPagamento: new Date(item.dataPagamento).toLocaleString("pt-MZ", { dateStyle: "short", timeStyle: "short" }),
                        }))
                            ?? []}
                        columnNamesMap={columnNamesMap}
                        totalPages={1}
                        onPageChange={handlePageChange}
                        pageSize={pageSize}
                        onPageSizeChange={handlePageSizeChange}
                        currentPage={currentPage}
                        totalItems={data?.totalRegistos ?? 0}
                        enablePaginate={false}
                        enableExportToExcel={true}
                        exportFileName={`Relatorio_Pagamentos_${new Date().toISOString()}.xlsx`}
                        footerContent={
                            <div style={{ fontWeight: "bold", padding: "8px" }}>
                                Total Pago: {data?.totalPago?.toLocaleString("pt-MZ", {
                                    style: "currency",
                                    currency: "MZN",
                                })}
                            </div>
                        }
                    />
                )}
            />
        </>
    );
};
